// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".musicianTrackWithEmptyInfoInside_root__3hYeo {\n  height: 54px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer; }\n  .musicianTrackWithEmptyInfoInside_root__3hYeo .musicianTrackWithEmptyInfoInside_label__2YabL {\n    color: red;\n    text-decoration: underline; }\n", ""]);
// Exports
exports.locals = {
	"root": "musicianTrackWithEmptyInfoInside_root__3hYeo",
	"label": "musicianTrackWithEmptyInfoInside_label__2YabL"
};
module.exports = exports;
